import type { Role } from '@/entities/user';

/** Global catalog admin APIs are `SUPER_ADMIN` on the gateway — UI matches `admin` only. */
export const catalogAccessRoles = ['admin'] as const satisfies readonly Role[];
